import _ from 'lodash';
export type DiceRoll = 1 | 2 | 3 | 4 | 5 | 6;
export const rollDie = () => _.random(1, 6) as DiceRoll;
export const rollDice = (n: number) => _.range(n).map(rollDie);
